const mapAppliedStoreFilters = (appliedStoreFilters)=>Object.entries(appliedStoreFilters).flatMap(([filterName, options])=>options.map((option)=>({
                name: filterName,
                value: option
            })
        )
    )
;

export { mapAppliedStoreFilters };
//# sourceMappingURL=map-applied-store-filters.js.map
